// Internal
import appTypes from 'shared/utils/actions';

const google = appTypes.defineAction('google');

export const GOOGLE_API_LOAD = google.defineAction('GOOGLE_API_LOAD', [
  'SUCCESS',
  'FAILURE',
]);

export const GOOGLE_AUTH2_API = google.defineAction('GOOGLE_AUTH2_API', [
  'LOAD_SUCCESS',
  'LOAD_FAILURE',
  'INIT_SUCCESS',
  'INIT_FAILURE',
]);
